export const BUTTON_IDS = {
    TOP_NAV: {
        HOME_PAGE_LOGO: "Nav - homepage_logo",
        GO_MOBILE: "Nav - Go Mobile",
        GO_BROADBAND: "Nav - Go Broadband",
        ABOUT_GOMO: "Nav - About Gomo",
        NEED_HELP: "Nav - Need Help?",
        MY_GOMO: "Nav - MyGomo",
        LOGIN: "Nav - Login",
        LOGOUT: "Nav - Logout",
        CART_ICON: "Cart Icon",
    },
    CAROUSEL: {
        GET_BROADBAND: "Carousel_CTA 1",
        GET_MOBILE: "Carousel_CTA 2",
    },
    HOME_PAGE: {
        GO_MOBILE: "home_page_cta Go Mobile",
        GO_BROADBAND: "home_page_cta Go Broadband",
    },
    MOBILE_FLOW: {
        STICKY: {
            BUY_NOW: "Sticky_Buy now",
            VIEW_BASKET: "Sticky_View your basket",
        },
        PAGE_CTA: {
            BUY_GOMO_MOBILE: "LP_CTA_Buy GoMo Mobile",
            ADD_ANOTHER_GOMO_MOBILE: "LP_CTA_Add another GoMo Mobile",
            GO_TO_MY_GOMO: "LP_CTA_Go to myGoMo",
            GO_TO_CART: "LP_CTA_Go to cart",
        },
        DRAWER_CTA: {
            CAN_I_GET_BROADBAND: "Drawer_prequal_Can i get broadband ?",
            BUY_BROADBAND: "Drawer_add_to_cart_Buy broadband",
            SKIP_AND_CONTINUE_TO_CART: "Drawker_Skip and continue to cart",
            CLOSE: "Drawer_X",
            BOOST_MY_BROADBAND: "Drawer_add_to_cart_Boost my broadband",
            CONTINUE_TO_BASKET: "Drawer_Continue to Basket",
        },
    },
    BROADBAND_FLOW: {
        STICKY: {
            CHECK_AVAILABILITY: "Sticky_Check availability",
            CONTINUE_TO_BASKET: "Sticky_Continue to Basket",
        },
        PAGE_CTA: {
            CAN_I_GET_GOMO_BROADBAND: "Prequal_CTA_Can I get GoMo broadband?",
        },
        ADD_TO_CART_CTA: {
            BUY_BROADBAND: "Add_to_cart_Buy broadband",
            BOOST_MY_BROADBAND: "Add_to_cart_Boost my broadband",
        },
        LOGIN_CTA: {
            LOGIN_AS_EXISTING_CUSTOMER: "LOGIN_CTA_Login as existing customer",
            ADD_GOMO_MOBILE_AND_CONTINUE: "Login_CTA_Add GoMo mobile and continue",
        },
    },
    EXISTING_USER_FLOW: {
        GOMO_FIBRE_BROADBAND: "CS_GoMo Fibre Broadband",
        GOMO_MOBILE: "CS_GoMo Mobile",
    },
    CHECKOUT_CTA: {
        MY_DETAILS: "Checkout_CTA_Next: My Details",
        INSTALLATION: "Checkout_CTA_Next: Installation",
        PAYMENT: "Checkout_CTA_Next: Payment",
    },
};
